<template>
  <v-card>
    <div v-if="showFollowUpTip">
      <v-toolbar color="primary">
        <v-toolbar-title class="body-2">
          <span class="headline">Follow Up</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-checkbox
          v-model="FollowUpChecked"
          color="primary"
          hide-details
        >
          <template v-slot:label>
            <div class="f-s-18">
              As per Customer's Request
            </div>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="saveFollowUpTip" :disabled="!FollowUpChecked">Save</v-btn>
      </v-card-actions>
    </div>
    <div v-else>
      <v-toolbar color="primary">
        <v-toolbar-title class="body-2">
          <span class="headline">Follow Up</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container fluid>
            <v-layout row>
              <v-radio-group v-model="radioGroup" row>
                <v-radio label="Relative" value="relative"></v-radio>
                <v-radio label="Absolute" value="absolute"></v-radio>
              </v-radio-group>
            </v-layout>
            <v-layout row v-if="radioGroup === 'relative'">
              <v-flex lg5>
                <v-text-field v-model="hours" type="number" hide-details></v-text-field>
              </v-flex>
              <v-flex lg1>
                <v-subheader>Hours</v-subheader>
              </v-flex>
              <v-flex lg5>
                <v-text-field v-model="minutes" type="number" hide-details></v-text-field>
              </v-flex>
              <v-flex lg1>
                <v-subheader>Minutes</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout v-if="radioGroup === 'absolute'">
              <v-flex lg6 p-r-20>
                <arb-date-picker-menu v-model="datePicker.date" label="Date"></arb-date-picker-menu>
              </v-flex>
              <v-flex lg6 p-l-20>
                <arb-time-picker-menu v-model="datePicker.time" label="Time"></arb-time-picker-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="radioGroup === 'relative'">
        <span v-if="relativeSaveDisabled" class="text-red m-l-10 tip-info">{{ tipMessage }}</span>
        <v-spacer></v-spacer>
        <v-btn text @click="saveFollowUpTime" :disabled="relativeSaveDisabled">Save</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <span v-if="absoluteSaveDisabled" class="text-red m-l-10 tip-info">{{ tipMessage }}</span>
        <v-spacer></v-spacer>
        <v-btn text @click="saveFollowUpTime" :disabled="absoluteSaveDisabled">Save</v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { OriginationBusinessApi } from '@/api/pandaria'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'follow-up-dialog',
  props: {
    loanId: Number
  },
  data () {
    return {
      valid: true,
      radioGroup: 'relative',
      hours: null,
      minutes: null,
      datePicker: {
        date: '',
        time: ''
      },
      relativeSaveDisabled: false,
      absoluteSaveDisabled: false,
      tipMessage: 'The Follow Up time must be no more than 24 hours from now',
      FollowUpChecked: false,
      showFollowUpTip: true
    }
  },
  watch: {
    hours (val) {
      if (tool.isNotEmpty(val)) {
        this.getDateDiff()
      }
    },
    minutes (val) {
      if (tool.isNotEmpty(val)) {
        this.getDateDiff()
      }
    },
    datePicker: {
      handler (val) {
        this.absoluteSaveDisabled = false
        if (tool.isNotEmpty(val.date) && tool.isNotEmpty(val.time)) {
          const followUpTime = val.date + ' ' + val.time
          const currentTime = new Date().getTime()
          const total = parseInt((new Date(followUpTime) - new Date(currentTime)) / 1000)
          if (total >= 24 * 60 * 60) {
            this.absoluteSaveDisabled = true
            this.tipMessage = 'The Follow Up time must be no more than 24 hours from now'
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getDateDiff () {
      if (Number(this.hours) < 0 || Number(this.minutes) < 0) {
        this.relativeSaveDisabled = true
        this.tipMessage = 'The value must be greater than  0'
        return false
      }
      this.relativeSaveDisabled = false
      const minutes = parseInt(this.minutes / 60)
      const hours = Number(this.hours) + minutes
      const leftMinutes = this.minutes % 60
      if (hours > 24) {
        this.relativeSaveDisabled = true
        this.tipMessage = 'The Follow Up time must be no more than 24 hours from now'
      } else if (hours === 24 && leftMinutes > 0) {
        this.relativeSaveDisabled = true
        this.tipMessage = 'The Follow Up time must be no more than 24 hours from now'
      }
    },
    hideDialog () {
      this.hours = null
      this.minutes = null
      Object.assign(this.$data, this.$options.data.call(this))
      this.$emit('hideDialog', 'FOLLOW_UP')
    },
    saveFollowUpTime () {
      const $this = this
      let followUpType
      const followUpData = {}
      if (this.radioGroup === 'relative') {
        followUpType = DataType.FollowUpType.RELATIVE.value
        if (tool.isEmpty(this.hours) || tool.isEmpty(this.minutes)) {
          popup.popupForWarning('Please complete date and time')
          return
        }
        followUpData.followUpAt = {
          hours: this.hours.replace(/[^0-9]/gi, ''),
          minutes: this.minutes.replace(/[^0-9]/gi, '')
        }
      } else {
        const date = this.datePicker.date
        const time = this.datePicker.time
        if (tool.isEmpty(date) || tool.isEmpty(time)) {
          popup.popupForWarning('Please complete date and time')
          return
        }
        followUpType = DataType.FollowUpType.ABSOLUTE.value
        followUpData.followUpAt = date + ' ' + time
      }

      followUpData.followUpType = followUpType
      followUpData.loanId = this.loanId

      OriginationBusinessApi.replaceFollowUpData(
        followUpData,
        function () {
          popup.popupForSuccess()
          $this.$eventBus.$emit('updateFollowUpData')
        },
        function (res) {
          const message = tool.isNotEmpty(res.data?.message) ? res.data.message : res.message
          popup.popupForError(message)
        }
      )
      this.hideDialog()
    },
    saveFollowUpTip () {
      if (this.FollowUpChecked) {
        this.showFollowUpTip = !this.showFollowUpTip
      }
    }
  }
}
</script>
<style lang="css" scoped>
.tip-info {
  border: #d9534f solid 1px;
  border-radius: 5px;
  padding: 5px 10px;
}
</style>
